// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble{position:absolute;border-radius:50px;opacity:.4}.bubble-orange{background:#ff9f59}.bubble-red{background:#ff5964}.bubble-blue{background:#46aeff}.bubble-green{background:#8de57b}.bubble-sm{width:70px;height:70px}.bubble-md{width:70px;height:70px}", ""]);
// Exports
module.exports = exports;
